(function(w,d){
  if(w.__swProductControls)return; w.__swProductControls=true;
  function q(s,c){return (c||d).querySelector(s)}
  function qa(s,c){return [].slice.call((c||d).querySelectorAll(s))}
  function setSizeReady(){
    var rg=q('[data-sw-rg]',d),ready=!!rg;d.documentElement.classList.toggle('sw-size-chart-ready',ready);
    if(ready){
      var trigger=rg.getAttribute('data-sw-trigger-label'),selector=rg.getAttribute('data-sw-selector-label');
      qa('.sw-size-chart-link span',d).forEach(function(el){if(trigger)el.textContent=trigger});
      if(selector){var h=q('.sw-size-chart-link',d);if(h){var row=h.closest('.sw-variant-heading-row');var label=row&&q('.sw-variant-heading',row);if(label)label.textContent=selector}}
    }
  }
  function placeQty(scope){
    qa('[data-sw-quantity-placement="beside_atc"]',scope||d).forEach(function(qty){
      if(qty.dataset.swInlineDone==='1')return;
      var parent=qty.parentElement;if(!parent)return;
      var buy=null,n=qty.nextElementSibling;
      while(n){if(n.classList&&n.classList.contains('x-block-buy-buttons')){buy=n;break}n=n.nextElementSibling}
      if(!buy)return;
      var form=q('form[data-type="add-to-cart-form"]',buy)||q('form',buy);
      var atc=q('.add_to_cart_button',buy);
      if(!form||!atc)return;
      var row=d.createElement('div');
      row.className='sw-inline-qty-atc-row'+(qty.getAttribute('data-sw-quantity-label')==='false'?' sw-inline-qty-no-label':'');
      var spacingId=qty.getAttribute('data-sw-spacing-id');
      if(spacingId){row.setAttribute('data-sw-spacing-id',spacingId);qty.removeAttribute('data-sw-spacing-id')}
      form.insertBefore(row,atc);
      row.appendChild(qty);
      row.appendChild(atc);
      qty.dataset.swInlineDone='1';
    });
  }
  function cleanTitles(scope){qa('.section-product-info img[title],.product-page img[title]',scope||d).forEach(function(im){im.removeAttribute('title')})}
  function init(scope){setSizeReady();placeQty(scope||d);cleanTitles(scope||d)}
  d.addEventListener('shopify:section:load',function(e){setTimeout(function(){init(e.target)},0)});
  d.addEventListener('shopify:section:unload',function(){setTimeout(setSizeReady,0)});
  d.addEventListener('shopify:block:select',function(){setTimeout(function(){init(d)},0)});
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',function(){init(d)},{once:true});else init(d);
})(window,document);
